import './PreviewDrawer.css';
import { useState } from 'react';
import { Drawer } from '@base-ui/react/drawer';
import { TbX } from 'react-icons/tb';
import { useTranslation } from 'react-i18next';
import LivePreview from 'Components/LivePreview/LivePreview';
import PreviewFab from 'Components/PreviewFab/PreviewFab';

const PreviewDrawer = () => {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    return (
        <>
            <PreviewFab onClick={() => setOpen(true)} hidden={open} />

            <Drawer.Root open={open} onOpenChange={setOpen} swipeDirection="down">
                <Drawer.Portal>
                    <Drawer.Backdrop className="preview-drawer-backdrop" />
                    <Drawer.Viewport className="preview-drawer-viewport">
                        <Drawer.Popup className="preview-drawer-popup">
                            <div className="preview-drawer-drag-area">
                                <span className="preview-drawer-drag-spacer" aria-hidden="true" />
                                <div className="preview-drawer-handle" aria-hidden="true" />
                                <Drawer.Close
                                    className="preview-drawer-close"
                                    aria-label={t('profile.preview.close')}
                                >
                                    <TbX size={18} />
                                </Drawer.Close>
                            </div>
                            <Drawer.Content className="preview-drawer-content">
                                <div className="preview-drawer-inner">
                                    <LivePreview />
                                </div>
                            </Drawer.Content>
                        </Drawer.Popup>
                    </Drawer.Viewport>
                </Drawer.Portal>
            </Drawer.Root>
        </>
    );
};

export default PreviewDrawer;
